import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b294ca62")

_pushScopeId("data-v-b294ca62")
const _hoisted_1 = {
  key: 0,
  class: "order-result__view"
}
const _hoisted_2 = { class: "view__header" }
const _hoisted_3 = { class: "paid-date" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_5 = { class: "view__body" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, " 결제수단 ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "-bold" }, " 총 결제금액 ", -1)
const _hoisted_8 = { class: "-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (!!_ctx.paidItem)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h3", null, _toDisplayString(_ctx.Title), 1),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.PaidDateTime), 1)
        ]),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("ul", null, [
            _createVNode("li", null, [
              _hoisted_6,
              _createVNode("span", null, _toDisplayString(_ctx.paidItem.PayMethod ?? "수동"), 1)
            ]),
            _createVNode("li", null, [
              _hoisted_7,
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.format.moneyToString(_ctx.paidItem.PaidAmmount.valueOf())), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})